import styled, { css } from "styled-components";
import TitleContainer from "../TitleContainer";
import FaultSwitch from "./FaultsSwitch";
import {
  flexBoxCenter,
  flexDirectionColumn,
  justifyContentFlexStart,
  justifyContentSpaceAround,
  layerA,
  layerA90Deg,
  layerCLighter,
} from "../styles/commonStyles";
import { useMediaQuery } from "react-responsive";
import { useViewport } from "use-viewport";
import { useSelector } from "react-redux";
import { selectFaults } from "../store/slices/FaultsSlice";
import { selectEssSwitch } from "../store/slices/essSwitchSlice";
import { useGetAllSSRsQueries, useGetThermocouplesQueries } from "../../hooks";
import { selectTesSwitch } from "../store/slices/tesSwitchSlice";
import { selectUserInfo } from "../store/slices/userSlice";

const FaultsMain = () => {
  const isMobile = useMediaQuery({ query: "(max-width:600px)" });

  const { height } = useViewport();

  const { flatEssSwitch } = useSelector(selectEssSwitch);
  const { flatTesSwitch } = useSelector(selectTesSwitch);
  const { isEssSwitch, isTesSwitch, isTgsSwitch, isHpSwitch, isAteSwitch } =
    useSelector(selectUserInfo);
  useGetAllSSRsQueries(flatEssSwitch, "ESS");
  useGetAllSSRsQueries(flatTesSwitch, "TES");
  useGetThermocouplesQueries(flatEssSwitch, "ess");
  useGetThermocouplesQueries(flatTesSwitch, "tes");
  const faultsState = useSelector(selectFaults);
  const essFaultMessages = faultsState.messages.ess;
  const tgsFaultMessages = faultsState.messages.tgs;
  const tesFaultMessages = faultsState.messages.tes;

  const faults = [
    {
      name: "ess",
      title: "electric switch systems",
      disabled: !isEssSwitch,
      message: essFaultMessages,
      comments: [],
    },
    {
      name: "tgs",
      title: "typhoon gas systems",
      disabled: !isTgsSwitch,
      message: tgsFaultMessages,
      comments: [],
    },
    {
      name: "tes",
      title: "typhoon electric systems",
      disabled: !isTesSwitch,
      message: tesFaultMessages,
      comments: [],
    },
    {
      name: "hp",
      title: "heating platforms",
      disabled: !isHpSwitch,
      message: [],
      comments: [],
    },
    {
      name: "ate",
      title: "additional track equipment",
      disabled: !isAteSwitch,
      message: [],
      comments: [],
    },
  ];
  return (
    <>
      {isMobile ? (
        <BaseLayer height={height - 156}>
          <WrapperMobile height={height - 162}>
            <TitleContainer title="faults" />
            <MobileSectionContent>
              {faults.map((fault) => (
                <FaultSwitch
                  key={fault.name}
                  name={fault.name}
                  title={fault.title}
                  disabled={fault.disabled}
                  message={fault.message}
                  comments={fault.comments}
                />
              ))}
            </MobileSectionContent>
          </WrapperMobile>
        </BaseLayer>
      ) : (
        <Wrapper>
          <TitleContainer title="faults" />
          <SectionContent>
          {faults.map((fault) => {
              return (
                <FaultSwitch
                  key={fault.name}
                  name={fault.name}
                  title={fault.title}
                  disabled={fault.disabled}
                  message={fault.message}
                  comments={fault.comments}
                />
              )
            })}
          </SectionContent>
        </Wrapper>
      )}
    </>
  );
};

export default FaultsMain;

const BaseLayer = styled.div`
  width: 332px;
  height: auto;
  ${({ height }) =>
    height
      ? css`
          min-height: ${height}px;
        `
      : css`
          min-height: 100vh;
          min-height: 100dvh;
        `}

  padding-top: 3px;
  padding-bottom: 3px;

  ${layerCLighter}
  border-radius: 31px 31px 36px 13px;
  ${flexBoxCenter}
  opacity: 1;
`;

const WrapperMobile = styled.div`
  width: 326px;
  height: auto;
  ${({ height }) =>
    height
      ? css`
          min-height: ${height}px;
        `
      : css`
          min-height: 100vh;
          min-height: 100dvh;
        `}
  padding-top: 4px;
  padding-bottom: 4px;

  ${layerA90Deg}
  border-radius: 28px 28px 33px 10px;

  border: 1px solid #000000;
  opacity: 1;
  ${justifyContentFlexStart}
  flex-direction: column;
`;

const MobileSectionContent = styled.div`
  width: 100%;
  height: auto;
  margin-top: 10px;
  ${flexBoxCenter}
  flex-direction: column;
  gap: 5px;
`;

const Wrapper = styled.div`
  width: 1216px;
  height: auto;
`;

const SectionContent = styled.section`
  width: 1216px;
  height: auto;
  border-radius: 40px;

  ${layerA};
  ${flexDirectionColumn};
  margin-top: 5px;
  padding: 2px 0;
`;
